export default class SKU {
  public _value!: string
  constructor (value: string | number) {
    this.parse(value)
  }

  parse (value: string | number) {
    this._value = String(value || '').trim().toLowerCase().split(' ').filter(s => Boolean(s) && s !== ' ').join('-')
  }

  get value () {
    return this._value
  }
}
